// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e13ef2a7","513":"dd25c056","703":"0d0e28a3","787":"38f16daf"}[chunkId] + ".chunk.js";
};